export default __webpack_public_path__ + "9db4fb9cdca65d8c5895c8f45803c97d.png";